module.exports = __webpack_public_path__ + "img/stack-overflow.1efb7f59.svg";